module.exports = {
    backUrl : 'https://threshold.data4risk.com',
    mapBoxToken :'pk.eyJ1Ijoiam9zZW5kIiwiYSI6ImNsZW9lcndmajAxbTczcm9kZDVmaHAwNmoifQ.uQpmWPQJPlSsAkNMrEnUiA',
    apiUrl : 'https://api.data4risk.com/api/alert'
}
